import styled from "styled-components";


export const SettingsWrapper = styled.div``
